module.exports = __webpack_public_path__ + "media/images/flags/64/Eritrea-ba422f210531cbaf5a20a640e6579c2d.png";